export class InvoiceAnticipationDTO {
    billetIds: number[];
    taxes: number;
    interest: number;
    accountId: number;
    idFavorecidoFinanceido: number;
    marinaCompany?: number;
}
